mutation CreateHifoCascade($hifoCascadeInput: HifoCascadeChangeInput!) {
  createHifoCascade(input: { hifoCascadeInput: $hifoCascadeInput }) {
    hifoCascade {
      id
    }
  }
}
